/// SWR fetcher that treats a non-2xx as the ERROR it is.
///
/// The shared `fetcher` resolves whatever JSON the server sent — fine for
/// endpoints whose failure mode is network-level, but the alkanes tables ride
/// on `unavailable = !!error`, and this API's refusals are 400s WITH a JSON
/// body (`{"error": …}`). Through the lenient fetcher that body "succeeds",
/// no field matches, and the table sits in its skeleton forever — neither
/// rows nor the honest "can't know" state. Throwing on !ok is what routes a
/// refusal (or an API that predates the endpoint) into `unavailable`.
export async function strictFetcher<T>(url: string): Promise<T> {
	const res = await fetch(url)
	if (!res.ok) {
		throw new Error(`HTTP ${res.status} for ${url}`)
	}
	return res.json() as Promise<T>
}
